<template>
  <div class="container-fluid py-4 px-4">
    <div class="row no-gutters">
      <div class="col-md-12">
        <base-table :max-height="560" :loading="isLoading" :loader-colspan="9">
          <template slot="table-header">
            <tr>
              <th scope="col" class="p-1" style="width: 5% !important;">
                <button class="btn btn-secondary btn-sm" data-toggle="tooltip" data-placement="right" title="Reload data" @click="viewCrewTon(crewTonId)">
                  <font-awesome-icon icon="undo"/>
                </button>
              </th>
              <!--<th colspan="5"></th>-->
            </tr>
           <tr>
             <th scope="col" class="p-1" style="width: 5% !important;">RANK</th>
             <th scope="col" class="p-1" style="width: 10% !important;">MANNING</th>
             <th scope="col" class="p-1" style="width: 25% !important;">NOTES FROM</th>
             <th scope="col" class="p-1" style="width: 10% !important;">TURN OVER NOTES</th>
             <th scope="col" class="p-1" style="width: 25% !important;">NOTES TO</th>
             <th scope="col" class="p-1" style="width: 5% !important;">REMARKS</th>
           </tr>
          </template>

          <template slot="table-body">
            <tr>
              <td>{{crewTon.rankName}}</td>
              <td>{{crewTon.manningAlias}}</td>
              <td>{{crewTon.assignedBy ? crewTon.assignedBy : '---'}}</td>
              <td>
<!--                <img v-if="crewTon.crewTonId"
                     :id="`img-excel-icon`"
                     class="img-thumbnail img-excel-icon"
                     :class="{
                          'bg-secondary':!crewTon.hasFile && crewTon.crewTonId,
                          'unclickable'  : isFileDownload,
                      }"
                     :src="excelIcon"
                     alt="File Icon"
                     @click="downloadfile(crewTon)">-->
                <button v-if="crewTon.crewTonId" class="btn-xs btn" @click="downloadfile(crewTon)"
                        :id="`img-icon`"
                        :class="{
                          'bg-secondary' : !crewTon.hasFile && crewTon.crewTonId,
                          'bg-success' : crewTon.hasFile,
                          'unclickable' : isFileDownload,
                        }">
                  <font-awesome-icon icon="fa-paperclip" class="img-icon" :class="{'text-white' : !crewTon.hasFile && crewTon.crewTonId,'text-white' : crewTon.hasFile}"/>
                </button>

              </td>
              <td>{{crewTon.assignedTo ? crewTon.assignedTo : '---'}}</td>
              <td>
                <button v-if="crewTon.remarks" class="btn btn-sm" @click="viewRemarks(crewTon)">
                  <font-awesome-icon icon="message" />
                  <sup class="pl-2 badge-pill badge-info">{{ crewTon.remarks.length }}</sup>
                </button>
              </td>
            </tr>
          </template>
        </base-table>
      </div>
    </div>

    <base-modal :modal-id="remarkModal" :modal-title="`Turnover notes remarks`" modal-size="lg">
      <template slot="modal-body">
        <base-table>
          <template slot="table-header">
            <tr>
              <th class="text-center align-middle font-weight-bold" style="width: 3% !important;">#</th>
              <th class="text-center align-middle font-weight-bold" style="width: 50% !important;">Remarks</th>
            </tr>
          </template>
          <template slot="table-body">
            <tr v-if="crewTonRemarks.length == 0">
              <td colspan="2">No records found.</td>
            </tr>
            <tr v-else v-for="(remark,index) in crewTonRemarks" :key="remark.remarkId">
              <td>{{ index + 1 }}</td>
              <td class="text-left align-middle">
                <div class="card mb-3 border-0">
                  <div class="card-header">
                    <div class="row">
                      <div class="col-5">
                        <label class="font-weight-bold col-form-label">{{ remark.remarksByName }}</label>
                      </div>
                      <div class="col-3">
                        <span class="pl-lg-2">( {{ remark.remarksTypeName ? remark.remarksTypeName : '---'  }} )</span>
                      </div>

                      <div class="col-4">
                        <span>[ {{ remark.createdAt }} ]</span>
                      </div>
                    </div>
                  </div>
                  <div class="card-body text-dark">
                    <!--<h5 class="card-title">Primary card title</h5>-->
                    <p class="card-text">{{ remark.remarks }}</p>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </base-table>
      </template>
    </base-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '../../mixins/app.mixins';
import {PosMixins} from '../../mixins/pos.mixins';
import excelIcon from '../../assets/excel.png'

export default {
  name: 'CrewViewTon',

  /** mixins **/
  mixins: [AppMixins,PosMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      excelIcon,
      remarkModal : 'remark-modal',
      crewTonId: Number.parseInt(this.$route.params.crewTonId, 10),
      isFileDownload : false,
    };
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
            'viewCrewTon',
            'setCrewTonRemarks',
            'downloadTonFile',
        ]
    ),


    loadData(){
      if(__.isEmpty(this.crewTon)){
        this.viewCrewTon(this.crewTonId)
      }
    },

    viewRemarks(ton){
      this.showThisModal(this.remarkModal)
      this.setCrewTonRemarks(ton?.remarks)
    },

    closeRemarks(){

    },

   async downloadfile(objTon){
      if(objTon.hasFile){
        let msgHtml = "<span>Do you want to download attach file</span>"
        if(await this.questionFormAlert(msgHtml,'Download attached file')){
          const formData = {
            crewTonId: objTon.crewTonId,
            fileName: `${objTon.rankName}_Turn_over_notes`,
          };
          this.isFileDownload = true
          this.downloadTonFile(formData).then((r)=>{
            if(r){
              this.isFileDownload = false;
              this.successFormAlert('Download successully')
            }
          })
        }
      }else {
        this.warningFormAlert('No file uploaded')
      }
    }
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
            'crewTon',
            'isLoading',
            'crewTonRemarks',
            'crewTonRemarks',
        ]
    )
  },

  /** mounted **/
  mounted() {
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },

  /** created **/
  created() {
    this.loadData();
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

.img-excel-icon {
  width: 30px !important;
  height: 30px !important;
}
</style>
